import React from 'react'
import styles from './detail-popover.scss'

const DetailPopover = (props) => {
	return (
		<div className={`${styles['detail-info-popover']} ${styles[props.itemKey]}`}>
			<div className={styles['arrow']} />
			<div>{props.info}</div>
		</div>
	)
}

export default DetailPopover
